<a
  [routerLink]="detalleLink"
  class="group bg-white rounded-2xl shadow-soft border border-outline-variant/30 flex flex-col gap-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-primary-glow hover:border-primary/30 overflow-hidden"
>
  @if (vacante.imagenUrl) {
    <img
      [src]="vacante.imagenUrl"
      [alt]="vacante.titulo"
      width="400"
      height="120"
      loading="lazy"
      class="w-full h-28 object-cover"
    />
  }
  <div class="flex flex-col gap-2.5 p-3.5" [class.pt-0]="vacante.imagenUrl">
    <div class="flex items-start justify-between gap-2.5">
      <div class="flex items-center gap-2.5 min-w-0">
        @if (vacante.empresa.logoUrl) {
          <img
            [src]="vacante.empresa.logoUrl"
            [alt]="'Logo de ' + vacante.empresa.nombreComercial"
            width="40"
            height="40"
            loading="lazy"
            class="w-10 h-10 rounded-xl object-cover border border-outline-variant/40 shrink-0 shadow-sm"
          />
        } @else {
          <div class="w-10 h-10 rounded-xl bg-teal-surface flex items-center justify-center text-primary shrink-0 shadow-sm">
            <span class="material-symbols-outlined text-xl">apartment</span>
          </div>
        }
        <div class="min-w-0">
          <h3 class="font-bold text-sm sm:text-base text-on-surface leading-snug group-hover:text-primary transition-colors line-clamp-2">{{ vacante.titulo }}</h3>
          <p class="text-xs text-on-surface-variant truncate mt-0.5">{{ vacante.empresa.nombreComercial }}</p>
        </div>
      </div>
      @if (vacante.matchPorcentaje) {
        <div class="shrink-0 bg-amber-highlight border border-secondary-container/40 text-secondary px-2 py-1 rounded-lg flex flex-col items-center">
          <span class="font-mono text-xs font-bold leading-none">{{ vacante.matchPorcentaje }}%</span>
          <span class="text-[8px] uppercase tracking-wide leading-none mt-0.5">match</span>
        </div>
      }
    </div>

    <div class="flex flex-wrap gap-1.5 text-[11px] text-on-surface-variant">
      <span class="inline-flex items-center gap-1 bg-surface-container-low px-2 py-0.5 rounded-md">
        <span class="material-symbols-outlined text-xs">location_on</span>
        {{ ubicacionTexto }}
      </span>
      <span class="inline-flex items-center gap-1 bg-surface-container-low px-2 py-0.5 rounded-md">
        <span class="material-symbols-outlined text-xs">work</span>
        {{ seniorityLabel }}
      </span>
    </div>

    @if (salarioTexto) {
      <div class="font-mono text-xs font-semibold text-primary pt-1 border-t border-outline-variant/20">{{ salarioTexto }}</div>
    }
  </div>
</a>
